import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '../../models/index';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-account-header',
    templateUrl: './account-header.component.html',
    styleUrls: ['./account-header.component.css'],
    standalone: false
})
export class AccountHeaderComponent implements OnInit, OnDestroy {
  @Input() activeTab: string = 'profile';
  @Output() scrollToSection = new EventEmitter<string>();

  isLoggedIn: any;
  user: User;
  private destroy$ = new Subject<void>();

  constructor(private router: Router, private users: UserService) {}

  ngOnInit() {
    this.users.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe((userData) => {
        this.isLoggedIn = this.users.isAuthenticated();
        this.user = userData ? new User().deserialize(userData) : new User();
      });

    this.isLoggedIn = this.users.isAuthenticated();
    if (!this.isLoggedIn) {
      this.router.navigateByUrl('/');
      return;
    }
    this.users.refreshAuthState();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateTo(section: string, event: Event) {
    event.preventDefault();
    this.scrollToSection.emit(section);
  }

  logoutUser() {
    this.users.logout();
    this.isLoggedIn = false;
    this.router.navigate(['/']);
  }
}
